import axios, { AxiosError } from 'axios'

export enum API {
  ADMIN = 'admin',
  CLIENT = 'client',
}


const ADMIN_API_URL = import.meta.env.VITE_ADMIN_API_URL || 'https://admin-api.hotglue.com/latest'
const CLIENT_API_URL = import.meta.env.VITE_CLIENT_API_URL || 'https://api.hotglue.com'


export type ApiError = {
  Message?: string
}

const adminApiInstance = axios.create({
  baseURL: ADMIN_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const clientApiInstance = axios.create({
  baseURL: CLIENT_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const fetcher = (params: [string, string | undefined, API]) => {
  const [url, apiKey, apiType] = params
  console.log(
    '[fetcher] url:',
    url,
    'apiKey:',
    apiKey ? 'present' : 'missing',
    'using:',
    apiType
  )

  const instance = apiType === API.CLIENT ? clientApiInstance : adminApiInstance

  return instance
    .get(url, {
      headers: apiKey ? { 'x-api-key': apiKey } : {},
    })
    .then((res) => {
      console.log('[fetcher] successful response:', url)
      return res.data
    })
    .catch((err: AxiosError<ApiError>) => {
      console.error('[fetcher] error:', err.message, url)
      const data = err?.response?.data
      throw data?.Message || err.message || 'Something went wrong, please try again.'
    })
}

export default {
  ADMIN: API.ADMIN,
  CLIENT: API.CLIENT,
}
